// 整合不同模块的api
import getTotalChatCount from './getTotalChatCount'
window.apis =  {
	...getTotalChatCount,
}
